import React from "react";
import { useI18n } from "../i18n";

export function Integrations() {
  const { t } = useI18n();

  const integrations = [
    { name: "Shopify", desc: t("integrations.shopify") },
    { name: "WordPress", desc: t("integrations.wordpress") },
    { name: "Wix", desc: t("integrations.wix") },
    { name: "Shopee", desc: t("integrations.shopee") },
    { name: "Custom HTML", desc: t("integrations.custom") },
    { name: "React / Next.js", desc: t("integrations.react") },
  ];

  return (
    <section className="py-20 px-6 relative overflow-hidden">
      {/* Animated scan line effect */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="onyx-scan-line" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t("integrations.title")}
          </h2>
          <p className="text-[#8a7a9a] text-lg max-w-2xl mx-auto">
            {t("integrations.subtitle")}
          </p>
        </div>

        {/* Code snippet showcase */}
        <div className="max-w-2xl mx-auto mb-16">
          <div className="rounded-xl border border-[#2a2040] overflow-hidden onyx-glow" style={{ background: "linear-gradient(145deg, #0d0b16, #14121e)" }}>
            <div className="px-4 py-3 border-b border-[#2a2040] flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-[#a078d0]/40"></div>
              <div className="w-3 h-3 rounded-full bg-[#7b5ea7]/40"></div>
              <div className="w-3 h-3 rounded-full bg-[#c0a0e0]/40"></div>
              <span className="ml-2 text-xs text-[#7a6a9a]">index.html — {t("integrations.codeLabel")}</span>
            </div>
            <div className="p-5 font-mono text-sm">
              <div className="text-[#7a6a9a]">&lt;!-- {t("integrations.codeComment")} --&gt;</div>
              <div className="mt-1">
                <span className="text-[#7b5ea7]">&lt;script</span>
              </div>
              <div className="pl-4">
                <span className="text-[#8a7a9a]">src=</span>
                <span className="text-[#a078d0]">"https://onyxai.chat/chat-widget.js"</span>
              </div>
              <div className="pl-4">
                <span className="text-[#8a7a9a]">data-api-key=</span>
                <span className="text-[#a078d0]">"your-api-key"</span>
              </div>
              <div>
                <span className="text-[#7b5ea7]">&gt;&lt;/script&gt;</span>
              </div>
              <div className="mt-3 text-[#7a6a9a]">&lt;!-- {t("integrations.codeDone")} --&gt;</div>
            </div>
          </div>
        </div>

        {/* Integration grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {integrations.map((int) => (
            <div
              key={int.name}
              className="p-4 rounded-xl text-center onyx-card onyx-glow-hover"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-lg bg-[#a078d0]/10 flex items-center justify-center">
                <span className="text-[#c0a0e0] text-lg font-bold">{int.name.charAt(0)}</span>
              </div>
              <p className="text-sm font-medium text-white mb-1">{int.name}</p>
              <p className="text-[10px] text-[#7a6a9a]">{int.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
